export default __webpack_public_path__ + "static/media/boomstamKlein.9c1acfc7.jpg";